export default "__VITE_ASSET__DZDtYxRI__"